import classNames from "../../../utils/classNames"
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export const ButtonInput = ({
  label = "",
  isSubmit = false,
  onClick,
  classes,
  disabled = false,
  children = <p></p>,
  isLoading = false,
  size = "md"
}) => {

  const sizeClasses = {
    sm: "px-2 py-1 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base"
  }

  return (
    <button
      className={classNames(
        label.length > 0 ? `shadow-sm bg-primary-600 hover:bg-primary-700 disabled:bg-gray-500 disabled:hover:bg-gray-500 text-white ${sizeClasses[size]}` //Text button
          : "text-primary-600 hover:text-primary-700 disabled:text-gray-500 disabled:hover:text-gray-500 text-sm", //Children button
        "rounded-md border border-transparent leading-4 font-medium focus:outline-none focus:ring-1 focus:ring-primary-500",
        classes)}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={`${isSubmit ? 'submit' : 'button'}`}
    >
      {isLoading ?
        <span className="flex items-center justify-center">
          <ArrowPathIcon className="animate-spin h-4 w-4" />
        </span>
        : label.length > 0 ? label : children}
    </button>
  )
}